import {LoanPaidInFull as LoanPaidInFullLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

export type LoanPaidInFullProps = {
  loadPaidInFullLetter: LoanPaidInFullLetter;
};

const LoanPaidInFull = (props: LoanPaidInFullProps) => {
  return (
    <>
      <CardField name="Agent Number" value={props.loadPaidInFullLetter.agentNumber} ddprivacy="mask"/>
      <CardField name="Date" value={toFormattedDateAsUTC(props.loadPaidInFullLetter.date)} ddprivacy="mask"/>
      <CardField name="Insured Name" value={props.loadPaidInFullLetter.insuredName} ddprivacy="mask"/>
      <CardField name="Owner Name" value={props.loadPaidInFullLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.loadPaidInFullLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Policy Number" value={props.loadPaidInFullLetter.policyNumber} ddprivacy="mask"/>
    </>
  );
};

export default LoanPaidInFull;
